import { render, staticRenderFns } from "./TreatmentCategoryDetails.vue?vue&type=template&id=99e2bbae&"
import script from "./TreatmentCategoryDetails.vue?vue&type=script&lang=js&"
export * from "./TreatmentCategoryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports